import { Component, Element, h, Host, Prop } from '@stencil/core'

import Helpers from '../../../utils/helpers'
import { CssClassMap } from '../../../utils/interfaces'

/**
 * ## Design System
 *
 * Para a documentação completa de design, incluindo diretrizes de uso, acessibilidade e exemplos visuais, consulte o [Design System do GovBR](https://www.gov.br/ds/components/header?tab=designer).
 *
 * @slot default - Slot para o conteúdo do link exibido no cabeçalho.
 */
@Component({
  tag: 'br-header-link',
  styleUrl: 'header-link.scss',
  shadow: true,
})
export class HeaderLink {
  /**
   * Referência ao elemento host do componente.
   * Utilize esta propriedade para acessar e manipular o elemento do DOM associado ao componente.
   */
  @Element() el: HTMLBrHeaderLinkElement

  /**
   * Identificador único; gerado automaticamente quando omitido.
   */
  @Prop({ reflect: true }) readonly customId: string = Helpers.generateUniqueId()

  /**
   * URL do link.
   */
  @Prop({ reflect: true }) readonly href: string = null

  /**
   * Define o alvo do link quando `href` está presente. Pode ser:
   * - `_blank` para abrir em uma nova aba,
   * - `_self` para abrir na mesma aba,
   * - `_parent` para abrir na aba pai,
   * - `_top` para abrir na aba superior.
   */
  @Prop({ reflect: true }) readonly target?: '_blank' | '_self' | '_parent' | '_top' = '_self'

  /**
   * Mapeia os nomes das classes CSS a serem aplicadas ao componente.
   * @returns Objeto com os nomes das classes CSS a serem aplicadas ao componente.
   */
  private getCssClassMap(): CssClassMap {
    return {
      'br-header-link': true,
    }
  }

  /**
   * Renderiza o componente.
   * @returns JSX do componente.
   */
  render() {
    return (
      <Host>
        <br-item id={this.customId} class={this.getCssClassMap()} density="large" href={this.href} target={this.target}>
          <slot></slot>
        </br-item>
      </Host>
    )
  }
}
